import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { FileSizeModule } from '@portal-core/general/pipes/file-size/file-size.module';
import { LicenseContactSalesDialogModule } from '@portal-core/licenses/components/license-contact-sales-dialog/license-contact-sales-dialog.module';
import { LicenseSubscriptionComponent } from './license-subscription.component';

@NgModule({
  declarations: [
    LicenseSubscriptionComponent
  ],
  imports: [
    CommonModule,
    FileSizeModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    LicenseContactSalesDialogModule,
    MatProgressBarModule,
    MatProgressSpinnerModule
  ],
  exports: [
    LicenseSubscriptionComponent
  ]
})
export class LicenseSubscriptionModule { }
